import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { IUserStore } from './types';

export const useUserStore = create<IUserStore>()(
  persist(
    (set) => ({
      authUser: null,
      setAuthUser: (user) => set({ authUser: user }),
    }),
    { name: 'user-store' },
  ),
);
